<template>
  <multi-picker
    :title="text"
    :icon="'/static/img/sort-light.svg'"
    :children="options"
    :is-active="checkIsActive"
    :close-on-click="false"
    @click-child="handleSelect"
  />
</template>

<script>
import {mapState} from "vuex";
import {ROOM_SORTABLE} from "../../../stores/search.store";
import MultiPicker from "./multi-picker";

export default {
  name: "search-sorter",
  components: {MultiPicker},
  data() {
    return {
      openState: false,
      preventTemper: null,
      options: [
        {value: {sort: ROOM_SORTABLE.AREA, direction: 'ASC'}, label: this.$t('v2.search.filter.AREA.ASC')},
        {value: {sort: ROOM_SORTABLE.AREA, direction: 'DESC'}, label: this.$t('v2.search.filter.AREA.DESC')},
        {value: {sort: ROOM_SORTABLE.PRICE, direction: 'ASC'}, label: this.$t('v2.search.filter.PRICE.ASC')},
        {value: {sort: ROOM_SORTABLE.PRICE, direction: 'DESC'}, label: this.$t('v2.search.filter.PRICE.DESC')},
      ]
    }
  },
  methods: {
    checkIsActive (child) {
      for (const value of this.storeValue) {
        if (value.sort === child.value.sort && value.direction === child.value.direction) {
          return true;
        }
      }
      return false;
    },
    handleSelect(child) {
      let found = false;
      for (const value of this.storeValue) {
        if (value.sort === child.value.sort && value.direction === child.value.direction) {
          found = true;
        }
      }
      if (!found) {
        this.$store.commit('search/ADD_SEARCH_SORTER', child.value);
        return;
      }
      this.$store.commit('search/REMOVE_SEARCH_SORTER', child.value);
    },
    choose(option) {
      this.$store.commit('search/SET_SEARCH_DIRECTION', option.value.direction);
      this.$store.commit('search/SET_SEARCH_SORT', option.value.sort);
      this.openState = false;
    }
  },
  computed: {
    ...mapState({
      storeValue: s => s.search.sorters
    }),
    text() {
      if (this.storeValue.length === 0) return this.$t('v2.search.filter.none');
      if (this.storeValue.length > 1) return this.$t('v2.search.filter.multi', this.storeValue.length);
      for (const option of this.options) {
        if (option.value.sort === this.storeValue[0].sort && option.value.direction === this.storeValue[0].direction) {
          return option.label;
        }
      }
      return this.$t('v2.search.filter.none');
    }
  }
}
</script>

<style scoped>
.picker-dropdown:not(.open) {
  display: none;
}
</style>




// WEBPACK FOOTER //
// src/pages/search/parts/search-sorter.vue